import React from 'react';
import SectionContainer from './SectionContainer';
import MetricDisplay from './MetricDisplay';
import TrendChart from './TrendChart';

function ReliabilitySection({ data, nationalAvg, utilityData, selectedYear }) {
  if (!data) {
    return (
      <SectionContainer icon="&#x26A1;" title="Reliability">
        <p className="text-sm text-gray-400">No reliability data available</p>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer icon="&#x26A1;" title="Reliability">
      <div className="space-y-1 divide-y divide-gray-100">
        <MetricDisplay
          label="SAIDI (Outage Duration)"
          value={data.saidi_without_med}
          unit=" min"
          nationalAvg={nationalAvg?.saidi_without_med}
          lowerIsBetter={true}
          precision={0}
        />

        <MetricDisplay
          label="SAIFI (Outage Frequency)"
          value={data.saifi_without_med}
          unit=" events"
          nationalAvg={nationalAvg?.saifi_without_med}
          lowerIsBetter={true}
          precision={2}
        />

        <MetricDisplay
          label="CAIDI (Avg Restoration)"
          value={data.caidi}
          unit=" min"
          nationalAvg={null}
          lowerIsBetter={true}
          precision={0}
        />
      </div>

      {/* Explanation */}
      <div className="mt-3 p-2 bg-gray-50 rounded text-xs text-gray-500">
        <strong>SAIDI</strong>: System Average Interruption Duration Index (minutes per customer per year)
        <br />
        <strong>SAIFI</strong>: System Average Interruption Frequency Index (interruptions per customer per year)
        <br />
        <strong>CAIDI</strong>: Customer Average Interruption Duration Index (avg restoration time)
        <br />
        <em>Values exclude Major Event Days (MEDs)</em>
      </div>

      {/* With/Without MED comparison */}
      {data.saidi_with_med && (
        <div className="mt-3 pt-3 border-t border-gray-100">
          <h4 className="text-xs font-medium text-gray-500 uppercase mb-2">Including Major Events</h4>
          <div className="grid grid-cols-2 gap-2 text-sm">
            <div>
              <span className="text-gray-500">SAIDI w/ MED: </span>
              <span className="text-gray-700">{data.saidi_with_med?.toFixed(0)} min</span>
            </div>
            <div>
              <span className="text-gray-500">SAIFI w/ MED: </span>
              <span className="text-gray-700">{data.saifi_with_med?.toFixed(2)}</span>
            </div>
          </div>
        </div>
      )}

      {/* Trend chart */}
      <div className="mt-3 pt-3 border-t border-gray-100">
        <h4 className="text-xs font-medium text-gray-500 uppercase">SAIDI Trend</h4>
        <TrendChart
          utilityData={utilityData}
          metricPath="reliability.saidi_without_med"
          selectedYear={selectedYear}
          label="SAIDI"
          unit=" min"
          color="#f59e0b"
          lowerIsBetter={true}
        />
      </div>

      {/* Data coverage warning for 2021+ */}
      {parseInt(selectedYear) >= 2021 && (
        <div className="mt-3 p-2 bg-yellow-50 border border-yellow-200 rounded text-xs text-yellow-700">
          <span className="font-medium">Limited Data:</span> Reliability metrics are reported by approximately 17% of utilities for {selectedYear}. National averages may not be fully representative.
        </div>
      )}

      {/* Data source */}
      <div className="text-xs text-gray-400 mt-3 pt-2 border-t border-gray-100">
        Source: EIA-861 Reliability Data
      </div>
    </SectionContainer>
  );
}

export default ReliabilitySection;
